import React, {useEffect} from 'react';
import { FaArrowCircleDown } from "react-icons/fa";
import { FaArrowCircleUp } from "react-icons/fa";
import { IoWarning } from "react-icons/io5";
import { TiWarning } from "react-icons/ti";
import { IoAddCircleOutline } from "react-icons/io5";
import { FaPencilAlt } from "react-icons/fa";
import { SlArrowDown } from "react-icons/sl";
import { FaMinusCircle } from "react-icons/fa";
import { GoDash } from "react-icons/go";
import CreateWifiSectionModal from '../component/WifiModules/CreateWifiSectionModal';
import EditWifiSectionModal from '../component/WifiModules/EditWifiSectionModal';
import EditWifiModuleModal from '../component/WifiModules/EditWifiModuleModal';
import WifiModulesPickerModal from '../component/WifiModules/WifiModulesPickerModal';
import WifiModuleControls from '../component/WifiModules/WifiModuleControls';
import {useTranslation} from 'react-i18next';
import axios from "axios";
import Button from '@mui/material/Button';
import { useSelector } from "react-redux";

export default function Controls({navigation}) {

  const currentMainThemeColor =  localStorage.getItem("currentMainThemeColor") ?? "#135c13";
  const currentSecondaryThemeColor =  localStorage.getItem("currentSecondaryThemeColor") ?? "#cfcfcf";

  const styles = {
    pageTitle: {
      padding: '2rem 1rem',
      marginBottom: '2rem',
      backgroundColor: currentSecondaryThemeColor, 
      borderRadius: '0.3rem',
      height: 200,
      display: 'flex',
      justifyContent: 'center',
    },
    addCircleIcon: {
      alignSelf: 'center', 
      marginEnd: 10, 
      marginTop: -8
    },
    seletionArrows:{
      alignSelf: 'center', 
      marginBottom: 10,
      marginLeft: 10, 
      cursor: 'pointer'
    },
    sectionCollapseIcon:{
      alignSelf: 'center',
      marginRight: 4,
      marginBottom: 18,
      borderStyle: 'solid',
      borderColor: currentMainThemeColor,
      borderWidth: 5,
      paddingStart: 10,
      paddingTop: 2,
      height: 25,
      cursor: 'pointer',
    },
    sectionWifiModuleContainer: {
      marginTop: 32,
      display: 'flex',
      width: '100%',
      alignSelf: 'center',
      justifyContent: 'center',
      alignItems: 'center',
      background: "#b90000",
    },
    sectionContainer: {
      marginTop: 32,
      paddingHorizontal: 24,
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
    },
    sectionContainerTitle: {
      display: 'flex', 
      flexDirection: 'row'
    },
    sectionTitle: {
      fontSize: 28,
      fontWeight: '600',
      color: '#000000',
    },
    wifiModuleTitle: {
      fontSize: 20,
      fontWeight: '600',
    },
    sectionWifiSectionContainer: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      marginTop: 22,
      marginBottom: 12,
      paddingHorizontal: 24,
      width: '90%',
      borderRadius: 15,
      padding: 10,
      background: `${currentSecondaryThemeColor}80`,
    },
    sectionWifiSectionTitle: {
      fontSize: 24,
      fontWeight: '600',
      width: '100%',
      marginStart: -10,
      marginBottom: -10,
      display: 'flex',
      flexDirection: 'row',
    },
    sectionDescription: {
      marginTop: 8,
      fontSize: 18,
      fontWeight: '400',
    },
    highlight: {
      fontWeight: '700',
    },
    updatePencilIcon: {
      alignSelf: 'center', 
      marginEnd: 10,
      cursor: 'pointer'
    },
    removeIcon: {
      alignSelf: 'center', 
      marginLeft: 14,
      cursor: 'pointer'
    },
  };

  
  const activeGroup = localStorage.getItem("activeGroupId");

  const { user: currentUser } = useSelector((state) => state.auth);

  const BE_URI = process.env.REACT_APP_BE_URI;

  const {t, i18n} = useTranslation();

  const [sequenceToShow, setSequenceToShow] = React.useState([]);
  const [wifiSections, setWifiSections] = React.useState([]);
  const [wifiModules, setWifiModules] = React.useState([]);

  const [isCreateWifiSectionModalVisible, setIsCreateWifiSectionModalVisible] =
    React.useState(false);

  const [isEditWifiSectionModalVisible, setIsEditWifiSectionModalVisible] =
    React.useState(undefined);

  const [isWifiModulesPickerModalVisible, setIsWifiModulesPickerModalVisible] =
    React.useState(undefined);

  const [isEditWifiModuleModalVisible, setIsEditWifiModuleModalVisible] =
    React.useState(undefined);

  const Section = ({children, title, icon}) => {
    return (
      <div style={styles.sectionContainer} >
        <div style={styles.sectionContainerTitle}>
        <p style={{color: '#000000',}}>{title}</p>
          {icon}
        </div>
          {children}
      </div>
    );
  };

  const WifiModuleSection = ({title, wifiModule, wifiSection}) => {
    return (
      <div className="sectionWifiModuleContainer" >
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              marginTop: 15,
              justifyContent: 'center',
              alignItems: 'center',
            }}>
              <FaPencilAlt
                name={'pencil'}
                color={currentMainThemeColor}
                size={30}
                style={styles.updatePencilIcon}
                onClick={() => {
                  setIsEditWifiModuleModalVisible(wifiModule);
                }}
              />
            {title}
            <FaMinusCircle
              color={currentMainThemeColor}
              size={28}
              style={styles.removeIcon}
              onClick={() => {
                handleRemoveWifiModuleFromWifiSection(wifiSection, wifiModule);
              }}
            />
          </div>
           <WifiModuleControls activeGroup={activeGroup} wifiModule={wifiModule} t={t} i18n={i18n} />
        </div>
    );
  };

  const SectionWifiSection = ({children, wifiSection}) => {
    const currentMaxSequence = Math.max.apply(
      Math,
      wifiSections.map(wS => wS.sequence),
    );
    const currentMinSequence = Math.min.apply(
      Math,
      wifiSections.map(wS => wS.sequence),
    );
    const isLowestSequence = wifiSection.sequence === currentMinSequence;
    const isHighestSequence = wifiSection.sequence === currentMaxSequence;
    const isShown = sequenceToShow.includes(wifiSection.sequence);

    return (
      <div style={styles.sectionWifiSectionContainer}>
        <div style={styles.sectionWifiSectionTitle}>
          {!isShown?<SlArrowDown 
            color={currentMainThemeColor}
            onClick={() => {
              isShown
                ? setSequenceToShow([
                    ...sequenceToShow.filter(wS => wS != wifiSection.sequence),
                  ])
                : setSequenceToShow([...sequenceToShow, wifiSection.sequence]);
            }}
            size={20}
            style={styles.sectionCollapseIcon}/>
            : 
            <GoDash
            color={currentMainThemeColor}
            onClick={() => {
              isShown
                ? setSequenceToShow([
                    ...sequenceToShow.filter(wS => wS != wifiSection.sequence),
                  ])
                : setSequenceToShow([...sequenceToShow, wifiSection.sequence]);
            }}
            size={20}
            style={styles.sectionCollapseIcon} />}
          {isShown && (
            <FaPencilAlt
              name={'pencil'}
              color={currentMainThemeColor}
              size={30}
              style={styles.seletionArrows}
              onClick={() => {
                setIsEditWifiSectionModalVisible(wifiSection);
              }}
            />
          )}
          <p style={styles.sectionTitle}>
            {wifiSection.name}
          </p>
          {!isLowestSequence && isShown && (
            <FaArrowCircleUp
              name={'arrow-up'}
              onClick={() => {
                handleUpdateSequenceWifiSection(wifiSection, true, true);
              }}
              color={currentMainThemeColor}
              size={30}
              style={styles.seletionArrows}
             />
          )}
          {!isHighestSequence && isShown && (
            <FaArrowCircleDown
              name={'arrow-down'}
              onClick={() => {
                handleUpdateSequenceWifiSection(wifiSection, false, true);
              }}
              color={currentMainThemeColor}
              size={30}
              style={styles.seletionArrows}
             />
          )}
          {unAssociatedWifiModules.length > 0 && (
            <Button
              onClick={() => {
                setIsWifiModulesPickerModalVisible(wifiSection);
              }}
              style={{marginTop: 10, marginStart: 5}}>
              <IoAddCircleOutline size={30} style={styles.addCircleIcon} />
            </Button>
          )}
        </div>
        {children}
      </div>
    );
  };

  

  const openCreateWifiSection = async () => {
    setIsCreateWifiSectionModalVisible(true);
  };

  const getWifiSections = async () => {

    const formData = {
      groupId: activeGroup,
    };
    const headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: `Bearer ${currentUser.token}`, 
    };
    const res = await axios.post(BE_URI + '/wifiSectionsByGroupId', formData, { headers });
    if (res.data.success) {
      setWifiSections(res.data.wifiSections);
    }
  };

  const getWifiModules = async () => {
    const formData = {
      groupId: activeGroup,
    };
    const headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      authorization: `Bearer ${currentUser.token}`, 
    };
    const res = await axios.post(BE_URI + '/wifiModulesByGroupId', formData, { headers });
    if (res.data.success) {
      setWifiModules(res.data.wifiModules);
    }
  };

  const handleRemoveWifiModuleFromWifiSection = async (
    wifiSection,
    wifiModule,
  ) => {
    try {
      const newWifiModule = wifiSection.wifiModules.filter(
        wM => wM != wifiModule._id,
      );
      const formData = {
        wifiSection: {
          _id: wifiSection._id,
          wifiModules: newWifiModule,
        },
      };
      const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        authorization: `Bearer ${currentUser.token}`, 
      };
      const res = await axios.put(BE_URI + '/update-wifiSection', formData, { headers });

      if (res.data.success) {
        const oldWifiSections = wifiSections.filter(
          wS => wS._id != wifiSection._id,
        );
        const wifiSectionsToReturn = oldWifiSections
          ? [...oldWifiSections, res.data.wifiSection]
          : [res.data.wifiSection];
        setWifiSections([
          ...wifiSectionsToReturn.sort((a, b) => a.sequence > b.sequence),
        ]);
        /*Toast.showShortBottom(
          'Succesfully removed wifi module from wifi Sections!',
        );*/
        getWifiSections(); // TODO find a way to do it without fetching
      } else {
       // Toast.showShortBottom('Error: ' + res.data.message);
      }
    } catch (error) {
      //Toast.showShortBottom('Error: ' + error);
    }
  };

  const handleUpdateSequenceWifiSection = async (
    wifiSection,
    isUp,
    isFirst,
  ) => {
    try {
      const formData = {
        wifiSection: {
          _id: wifiSection._id,
          sequence: isUp ? wifiSection.sequence - 1 : wifiSection.sequence + 1,
        },
      };
      const headers = {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        authorization: `Bearer ${currentUser.token}`, 
      };
      const res = await axios.put(BE_URI + '/update-wifiSection', formData, { headers });

      if (res.data.success) {
        const wifiSequenceToSwap = wifiSections.find(
          wS => wS.sequence == formData.wifiSection.sequence,
        );
        if (isFirst)
          handleUpdateSequenceWifiSection(wifiSequenceToSwap, !isUp, false);
        const oldWifiSections = wifiSections.filter(
          wS => wS._id != wifiSection._id,
        );
        const wifiSectionsToReturn = oldWifiSections
          ? [...oldWifiSections, res.data.wifiSection]
          : [res.data.wifiSection];
        setWifiSections([
          ...wifiSectionsToReturn.sort((a, b) => a.sequence > b.sequence),
        ]);
        if (!isFirst) {
          /*Toast.showShortBottom(
            t("SuccesfullySwapedSequence"),
          );*/
          getWifiSections(); // TODO find a way to do it without fetching
        }
      } else {
       // Toast.showShortBottom(t("Error")+ res.data.message);
      }
    } catch (error) {
      // Toast.showShortBottom(t("Error") + error);
    }
  };

  useEffect(() => {
    getWifiSections();
    getWifiModules();
  }, [activeGroup]);

  const associatedWifiModuleIds = wifiSections.flatMap(
    section => section.wifiModules,
  );
  const unAssociatedWifiModules = wifiModules.filter(
    module => !associatedWifiModuleIds.includes(module._id),
  );

  if (
    JSON.stringify(activeGroup) == '{}' ||
    JSON.stringify(activeGroup) == '"0"'
  ) {
    return (
      <div style={{marginTop: 25}}>
        <div style={{display: 'flex', height: '100%', marginTop: 150}}>
          <IoWarning />

          <p
            style={{
              display: 'flex',
              textAlign: 'center',
              height: '100%',
              fontSize: 20,
            }}>
            {
              t("YouAreNotmemberAnyGroup")
            }
          </p>
        </div>
      </div>
    );
  }

  if(!activeGroup){
    return (
      <div className="container">
        <header className="jumbotron">
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
              <h1>{'Controls'}</h1>
            </div>
          </header>
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
            <p>{t("YouAreNotmemberAnyGroup")}</p>
          </div>
      </div>)
  }

  return (
    <div className="container">
      <header style={styles.pageTitle}>
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
            <h1>{'Controls'}</h1>
          </div>
        </header>
      <div style={{ marginBottom: 50, border: '1px solid #ccc' }}>
        <Section
          title={t("WifiSections")}
          icon={
            <Button
              onClick={openCreateWifiSection}
              >
              <IoAddCircleOutline size={30} style={{alignSelf: 'center', marginEnd: 10, marginTop: -8}} />
            </Button>
          }>            
          <div style={{ width: '100%', display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
            {unAssociatedWifiModules.length > 0 && (
              <div
                style={{
                  alignSelf: 'center',
                  display: 'flex',
                  flexDirection: 'row',
                  justifyContent: 'center',
                  marginTop: 25,
                  marginBottom: 15,
                }}>
                <TiWarning size={50} style={{marginTop: -8}} color={currentMainThemeColor} />
                <p>{t("WarningYouHave")}</p>
                <p
                  style={{
                    color: currentMainThemeColor,
                    fontSize: 30,
                    marginTop: -10,
                  }}>
                  {unAssociatedWifiModules.length}
                </p>
                <p>{t("UnAssociatedWifiModule")}</p>
                {unAssociatedWifiModules.length > 1 && <p>{'s'}</p>}
                <TiWarning size={50} style={{marginTop: -8}} color={currentMainThemeColor} />
              </div>
            )}
              {wifiSections
                .sort((a, b) => a.sequence > b.sequence)
                .map(wifiSection => {
                  const isShown = sequenceToShow.includes(wifiSection.sequence);
                  const associatedWifiModules = [];
                  wifiModules.filter(wM => {
                    wifiSection.wifiModules.includes('' + wM._id);
                  });
                  wifiModules.forEach(function (module, key) {
                    if (wifiSection.wifiModules.includes('' + module._id))
                      associatedWifiModules.push(module);
                  });

                  return (
                    <SectionWifiSection wifiSection={wifiSection}>
                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', /*transform: [{ translateX: (screenWidth/2) -180 }]*/}}>
                        {isShown &&
                          associatedWifiModules.map(wifiModule => {
                            return (
                              <WifiModuleSection
                                title={wifiModule.name}
                                wifiModule={wifiModule}
                                wifiSection={wifiSection}
                              />
                            );
                          })}
                        {isShown && associatedWifiModules.length == 0 && (
                          <p>{t("NoWifiModulesAssociated")}</p>
                        )}
                      </div>
                    </SectionWifiSection>
                  );
              })}
          </div>
        </Section>
        <CreateWifiSectionModal
          token={currentUser.token}
          wifiSections={wifiSections}
          setWifiSections={setWifiSections}
          activeGroup={activeGroup}
          buttonColor={currentMainThemeColor}
          modalVisible={isCreateWifiSectionModalVisible}
          setModalVisible={setIsCreateWifiSectionModalVisible}
          t={t}
        />
        <EditWifiSectionModal
          token={currentUser.token}
          selectedWifiSection={isEditWifiSectionModalVisible}
          wifiSections={wifiSections}
          getWifiSections={getWifiSections}
          setWifiSections={setWifiSections}
          activeGroup={activeGroup}
          buttonColor={currentMainThemeColor}
          modalVisible={isEditWifiSectionModalVisible}
          setModalVisible={setIsEditWifiSectionModalVisible}
          t={t}
        />
        <EditWifiModuleModal
          token={currentUser.token}
          selectedWifiModule={isEditWifiModuleModalVisible}
          wifiModules={wifiModules}
          getWifiModules={getWifiModules}
          setWifiModules={setWifiModules}
          activeGroup={activeGroup}
          buttonColor={currentMainThemeColor}
          modalVisible={isEditWifiModuleModalVisible}
          setModalVisible={setIsEditWifiModuleModalVisible}
          t={t}
        />
        <WifiModulesPickerModal
          token={currentUser.token}
          wifiModules={unAssociatedWifiModules}
          wifiSections={wifiSections}
          setWifiSections={setWifiSections}
          getWifiSections={getWifiSections}
          setWifiModules={setWifiModules}
          title={'Associate Wifi Module'}
          buttonColor={currentMainThemeColor}
          modalVisible={isWifiModulesPickerModalVisible}
          setModalVisible={setIsWifiModulesPickerModalVisible}
          t={t}
        /> 
      </div>
    </div>
  );
}
